import { BasicAccountInfo } from './BasicAccountInfo'

export const sections = [
  {
    id: '#basic-account-info',
    title: 'Basic Account Information',
    component: BasicAccountInfo,
  },
]
